<div class="scroll-top" @click.prevent="scrollTop" :class="{ 'is-active': isVisible }"><icon-chevron-top></icon-chevron-top></div>